<template>
    <div class="home-company-logo">
        <b-img
            class="image"
            :src="logoSrc"
        />
    </div>
</template>

<script>
    import './HomeCompanyLogo.scss';

    export default {
        name: "HomeCompanyLogo",

        props: {
            logoSrc: {
                type: String,
                required: true,
            }
        },
    };
</script>
